export default __webpack_public_path__ + "static/Card24-c441a8d35d8db70f71b474b879a1d46d.png";